import { render } from "./dealerAnalyze.vue?vue&type=template&id=1fc61804&scoped=true"
import script from "./dealerAnalyze.vue?vue&type=script&lang=js"
export * from "./dealerAnalyze.vue?vue&type=script&lang=js"

import "./dealerAnalyze.vue?vue&type=style&index=0&id=1fc61804&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc61804"]])

export default __exports__